import { CommonModule }     from '@angular/common';
import { FormsModule }      from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AttachmentFileModelDirective }  from '../../attachments/attachment.file-model.directive';
import { BoxTogglerDirective }           from '../../core/directives/box-toggler.directive';
import { CopyToClipboardDirective }      from './copy-to-clipboard/copy-to-clipboard.component';
import { CounterComponent }              from './counter.directive';
import { CurrencyInputDirective }        from './currency-input.directive';
import { DateInputDirective }            from './date-input.directive';
import { DatePickerButtonDirective }     from './date-picker-button/date-picker-button.directive';
import { FormSubmitValidatorDirective }  from './form-submit.validator.directive';
import { GiveFocusDesktopDirective }     from '../../core/directives/give-focus-desktop.directive';
import { GiveFocusDirective }            from '../../core/directives/give-focus.directive';
import { GridFilterDirective }           from '../../grids/grid.filter.directive';
import { LengthWarningDirective }       from './length-warning.directive';
import { NgEnterDirective }              from '../../../app/core/directives/ng-enter.directive';
import { NumberInputDirective }          from './number-input.directive';
import { QuantityInputDirective }        from './quantity-input.directive';
import { ReportDateInputDirective }      from './report-date-input.directive';
import { SaveRouteDirective }            from './save-route.directive';
import { ShortDateInputDirective }       from './short-date-input.directive';
import { SectionToggleDirective }        from '../../core/directives/section-toggle.directive';
import { SwitchInputDirective }          from './switch-input.directive';
import { TooltipDirective }              from './tooltip.directive';
import { TypeaheadDirective }            from './typeahead.directive';

@NgModule({
  declarations: [
    AttachmentFileModelDirective,
    BoxTogglerDirective,
    CopyToClipboardDirective,
    CounterComponent,
    CurrencyInputDirective,
    DateInputDirective,
    DatePickerButtonDirective,
    FormSubmitValidatorDirective,
    GiveFocusDesktopDirective,
    GiveFocusDirective,
    GridFilterDirective,
    LengthWarningDirective,
    NgEnterDirective,
    NumberInputDirective,
    QuantityInputDirective,
    ReportDateInputDirective,
    SaveRouteDirective,
    ShortDateInputDirective,
    SectionToggleDirective,
    SwitchInputDirective,
    TooltipDirective,
    TypeaheadDirective
  ],
  entryComponents: [
    CopyToClipboardDirective,
    CounterComponent
  ],
  exports: [
    // Third Party
    NgbTooltipModule,

    // Custom
    AttachmentFileModelDirective,
    BoxTogglerDirective,
    CopyToClipboardDirective,
    CounterComponent,
    CurrencyInputDirective,
    DateInputDirective,
    DatePickerButtonDirective,
    FormSubmitValidatorDirective,
    GiveFocusDesktopDirective,
    GiveFocusDirective,
    GridFilterDirective,
    LengthWarningDirective,
    NgEnterDirective,
    NumberInputDirective,
    QuantityInputDirective,
    ReportDateInputDirective,
    SaveRouteDirective,
    ShortDateInputDirective,
    SectionToggleDirective,
    SwitchInputDirective,
    TooltipDirective,
    TypeaheadDirective
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,

    // Third Party
    NgbTooltipModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class DirectivesModule {}
